var map = {
	"./es/faq_list.json": [
		2090,
		2090
	],
	"./it/faq_list.json": [
		67566,
		7566
	],
	"./pt/faq_list.json": [
		54396,
		4396
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 58149;
module.exports = webpackAsyncContext;